export class CreatePlaceCommand {
    public name: string;
    public description: string;
    public lat: number;
    public lng: number;
    public address: string;
    public category: string;
    public website: string;
    public defaultImage: string;
    public isHubCreated: boolean;
    public image: File;
    public imageLink: string;
    public ownerEmail: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/place/create.place.command.ts